import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Contact }          from "Utils/API";



// The initial State
const initialState = {
    loading    : true,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canFilter  : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    categories : [],
    activities : [],
    statuses   : [],
    sort       : {
        orderBy  : "finalPosition",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "CONTACT_LOADING" });
    },

    /**
     * Fetches the Contact List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await Contact.getAll(params);
        data.sort = params;
        dispatch({ type : "CONTACT_LIST", data });
    },

    /**
     * Fetches a single Contact
     * @param {Function} dispatch
     * @param {Number}   contactID
     * @returns {Promise}
     */
    async fetchElem(dispatch, contactID) {
        const data = await Contact.getOne({ contactID });
        dispatch({ type : "CONTACT_ELEM", data });
    },

    /**
     * Fetches the Contact Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Contact.getEditData();
        dispatch({ type : "CONTACT_EDIT", data });
    },

    /**
     * Edits/Creates a Contact
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Contact.edit(data);
    },

    /**
     * Deletes a Contact
     * @param {Function} dispatch
     * @param {Number}   contactID
     * @returns {Promise}
     */
    deleteElem(dispatch, contactID) {
        return Contact.delete({ contactID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "CONTACT_LIST", "CONTACT_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "CONTACT_LOADING":
        return {
            ...state,
            loading    : true,
        };

    case "CONTACT_LIST":
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canFilter  : action.data.canFilter,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : action.data.list,
            total      : action.data.total,
            sort       : action.data.sort,
        };

    case "CONTACT_ELEM":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            elem       : action.data.elem,
            categories : action.data.categories,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    case "CONTACT_EDIT":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            categories : action.data.categories,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
